import { clientEnvNodeEnvironmentIsProd } from "@/modules/client-env/nodeEnvironment";
import { clientEnvLocalBackendApiIsEnabled } from "@/modules/client-env/viteConfig";

export const clientEnvGetElectricBaseUrl = () => {
  const isProd = clientEnvNodeEnvironmentIsProd();
  const localBackendApiIsEnabled = clientEnvLocalBackendApiIsEnabled();

  if (localBackendApiIsEnabled) {
    return "http://localhost:8000/api/v2/electric/v1/shape";
  }

  if (isProd) {
    return "https://electric-prod.mem.engineering/api/v2/electric/v1/shape";
  }

  // We don't have a staging env yet, so just default to prod.
  return "https://electric-prod.mem.engineering/api/v2/electric/v1/shape";
};
